import { Injectable, Output, EventEmitter } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ApiService } from './api.service';
import { CorpInfo, AlertService } from 'app/services';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
declare var moment:any;

@Injectable()
export class PromotionService {
  @Output() companyListEe: EventEmitter<Array<CorpInfo>> = new EventEmitter();
  companyList: Array<CorpInfo>;
  
  @Output() accountListEe: EventEmitter<Array<CntryBannerItemModel>> = new EventEmitter();
  accountList: Array<CntryBannerItemModel>;

  constructor(private http: Http, private apiService:ApiService, private alertService: AlertService, private router: Router,) {
    this.apiService.get('admin/corps/status/1')
      .subscribe(
      resp => {
        this.companyList = resp.data;
        this.companyListEe.emit(this.companyList);
      },
      err => console.log("Error code: %s, URL: %s", err.status, err.url),
      () => {}
    );

    this.apiService.get('admin/banner/cntry/items')
      .subscribe(
        resp => {
          this.accountList = resp.data;
          this.accountListEe.emit(this.accountList);
        },
        err => console.log("Error code: %s, URL: %s", err.status, err.url),
        () => {}
      );
  };

  getAccountList(){
		return this.apiService.get('admin/banner/cntry/items');
  }
  
  postAccount(account) {
    return this.apiService.post('admin/banner/cntry/items', account);
  }

  patchAccount(account) {
    return this.apiService.patchReqDataType('admin/banner/cntry/items', account);
  }

  getCompanyList() {
    return this.apiService.get('admin/corps/status/1');
  }

  getContractList() {
    return this.apiService.get('admin/banner/contracts');
  }

  postContract(contract) {
    return this.apiService.post('admin/banner/contracts', contract, true);
  }

  patchContract(contract) {
    return this.apiService.patchReqDataType('admin/banner/contracts', contract);
  }

  deleteContract(contractId) {
    return this.apiService.delReqParamsType('admin/banner/contracts/' + contractId);
  }

  getStatisticsList(corpId, startDt, endDt) {
    let data = {
      corpId: corpId,
      strDt: startDt,
      endDt: endDt
    };

    return this.apiService.get('admin/statistics/banner/daily', data);
    
  }
}

export class CntryBannerItemModel {
  cntryBannerItemId: number;
	price: number;
	tier: number;
  max:number;
  sellCnt: number;
  countryCode: string;
	countryName: string;
}

export class ContractItemModel {
  corporation: CorpInfo;
  startDt: string;
  endDt: string;
  contractAmount: number;
  sellAmount: number;
  activityCountryCnt: number;
  bannerContractList: Array<BannerContract>;
} 

export class BannerContract {
  bannerContractId: number;
  corporation: CorpInfo;
  startDt: string = moment(new Date()).format('YYYYMMDD');;
  endDt: string = moment(new Date()).add(1, 'Y').format('YYYYMMDD');
  countryCode: string;
  countryName: string;
  contractAmount: number;
  sellAmount: number;
  remark: string;
  delYn:number;
  totalSellMonth: number;
  activityCountryCnt: number;
}

export class BannerStatistics {
  clickCnt: number;
  cntryNm: string;
  corpNm: string;
  viewCnt: number;
}


// WEBPACK FOOTER //
// ./src/app/services/promotion.service.ts